// extracted by mini-css-extract-plugin
export default {"circularProgress":"CircularProgress_circularProgress__oFbEV","circularProgressSpin":"CircularProgress_circularProgressSpin__GAtb3"};